"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "init", {
  enumerable: true,
  get: function get() {
    return _operations.init;
  }
});
Object.defineProperty(exports, "setItems", {
  enumerable: true,
  get: function get() {
    return _operations.setItems;
  }
});
Object.defineProperty(exports, "setSelection", {
  enumerable: true,
  get: function get() {
    return _operations.setSelection;
  }
});
Object.defineProperty(exports, "replace", {
  enumerable: true,
  get: function get() {
    return _operations.replace;
  }
});
Object.defineProperty(exports, "toggle", {
  enumerable: true,
  get: function get() {
    return _operations.toggle;
  }
});
Object.defineProperty(exports, "remove", {
  enumerable: true,
  get: function get() {
    return _operations.remove;
  }
});
Object.defineProperty(exports, "removeAll", {
  enumerable: true,
  get: function get() {
    return _operations.removeAll;
  }
});
Object.defineProperty(exports, "rangeTo", {
  enumerable: true,
  get: function get() {
    return _operations.rangeTo;
  }
});
Object.defineProperty(exports, "getItems", {
  enumerable: true,
  get: function get() {
    return _operations.getItems;
  }
});
Object.defineProperty(exports, "getSelection", {
  enumerable: true,
  get: function get() {
    return _operations.getSelection;
  }
});
Object.defineProperty(exports, "getChangedSelection", {
  enumerable: true,
  get: function get() {
    return _operations.getChangedSelection;
  }
});
Object.defineProperty(exports, "getChangedDeselection", {
  enumerable: true,
  get: function get() {
    return _operations.getChangedDeselection;
  }
});
exports.default = void 0;

var _selection = _interopRequireDefault(require("./selection"));

var _operations = require("./operations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _selection.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice/lib/index.js
// module id = 2
// module chunks = 0